import React, { useState, useEffect } from "react"
import { withRouter } from "react-router-dom";
import { Modal, Select, Row, Col, Form, Icon, Spin, DatePicker, Input, Button, Cascader, message } from "antd";
import moment from 'moment';
import jwtDecode from "jwt-decode";
import { consultaEmpresasSeguimiento, saveProduccion } from "../../api/seguimiento";
const antIcon = <Icon type="loading" style={{ fontSize: 30 }} spin />;

const { Option } = Select;

function FormActaSeguimiento (props){

    const tiempoMensaje = 5;
    const { getFieldDecorator } = props.form;

    const [disabledc,           setDisabledc]       = useState (true);
    const [loading,             setLoading]         = useState (false);

    const [options, setOptions] = useState({
        options: [],
        listaEmpresas: []
    });

    const [visibleAlert, setVisibleAlert] = useState({
        activado: false,
        tipoMensaje: "",
        mensaje: ""
    });

    const [objectForm, setObjectForm] = useState ({
        fechaInicio: "",
        fechaFin: "",
        cantidadTotal: 0,
        cantidadAcumulada: 0,
        fechaUltimoRegistro: "",
        nombreEmpresa: "",
        disabledDate: true
    })

    //ACCIONES QUE SE EJECUTAN AUTOMATICAMENTE AL CAMBIAR LA PROPIEDAD isVisible
    useEffect(()=>{
        if(props.isVisible){
            setDisabledc(true)//Al abrir el modal siempre se debe mostrar deshabilitado el campo de fecha captura/termino
            getEmpresasSeguimiento()
        }
    },[props.isVisible])

    //ACCIONES QUE SE EJECUTAN AUTOMATICAMENTE AL CAMBIAR la variable options
    useEffect(()=>{
        if(options && options.listaEmpresas.length == 1){
            const val = `${options.listaEmpresas[0].idAdjudicacion}-${options.listaEmpresas[0].idEmpresa}`
            onChangeFiltro(val)
        }
    },[options])

    //MÉTODO QUE OBTIENE EL LISTADO DE EMPRESAS ADJUDICADAS
    const getEmpresasSeguimiento = () =>{
        let data = JSON.stringify({
            idArticulo: parseInt(localStorage.getItem("ID_ARTICULO_SEG")),
            idEstado: parseInt(localStorage.getItem('ID_ESTADO_SELECCIONADO')),
            idTipoDocumentacion: parseInt(localStorage.getItem('ID_TIPO_DOC_SEG')),
            idAprobacion: parseInt(localStorage.getItem('ID_APROBACION_SEG'))
        })
        consultaEmpresasSeguimiento(data)
            .then(resp => {
                if (resp.data.entity.code === 200) {
                    let options = [];
                    resp.data.entity.listaEmpresas.map((item) => {
                        let idEmpresaSelect = item.idAdjudicacion + "-" + item.idEmpresa
                        options = [...options, { value: idEmpresaSelect, label: item.nombreEmpresa }];
                        
                    });
                    
                    setOptions({
                        options: options,
                        listaEmpresas: resp.data.entity.listaEmpresas
                    })
                } else if (resp.data.entity.code == 403) {
                    localStorage.clear();
                    window.location = "/login"
                }
                else {

                    setOptions({
                        options: [],
                        listaEmpresas: []
                    })

                    message.error(resp.data.entity.causa, tiempoMensaje);
                    props.setIsLoadingEmpresa(true);
                }
            }).catch(err => {
                if (err.response != null && err.response.status == 403) {
                    localStorage.clear();
                    window.location = "/login"
                    return;
                }
                setOptions({
                    options: [],
                    listaEmpresas: []
                })
                
                message.error("Ocurrió un error al obtener los documentos y materiales. Favor de intentar más tarde.", tiempoMensaje);
            })

    }

    //METODO QUE LIMPIA LOS CAMPOS AL CERRAR EL MODAL
    const handleCancel = () => {
        setOptions({
            options: [],
            listaEmpresas:[]
        })
        setObjectForm({
            options: null,
            listaEmpresas: null,
            fechaInicio: "",
            fechaFin: "",
            cantidadTotal: 0,
            cantidadAcumulada: 0,
            fechaUltimoRegistro: "",
            disabledDate: true,
            nombreEmpresa:""
        });

        props.form.resetFields();
        localStorage.removeItem("ID_ARTICULO_SEG");
        localStorage.removeItem("ID_TIPO_DOC_SEG");
        localStorage.removeItem("ID_APROBACION_SEG");
        localStorage.removeItem("NOMBRE_ARTICULO_SEG");

        props.setIsVisible(false);
        props.setIsLoadingEmpresa(true);

    }

    //METODO QUE SE EJECUTA AL SELECCIONAR UN ELEMENTO DEL SELECT
    const onChangeFiltro = (value) => {
        if (value !== null) {
            //El valor del option tiene el formato 'idAdjudicacion-idEmpresa' y para obtener cada uno se hace un split
            const splited = value.split("-");

            const registroAdjudicacion = options.listaEmpresas.filter(empresa => empresa.idAdjudicacion === splited[0]);
            const registroEmpresa = registroAdjudicacion.find(adjudicacion => adjudicacion.idEmpresa === splited[1]);
            
            props.form.resetFields();
            let hoy =moment().startOf('day')
            let fechaInicio = moment(registroEmpresa.fechaInicio, "DD-MM-YYYY").toDate();
            let fechaFin = moment(registroEmpresa.fechaFin, "DD-MM-YYYY").toDate();
            let disableDate = ((fechaInicio <= hoy) && (hoy <= fechaFin)) ? false : true;
            setObjectForm({
                fechaInicio: registroEmpresa.fechaInicio,
                fechaFin: registroEmpresa.fechaFin,
                cantidadTotal: parseInt(registroEmpresa.cantidadTotal),
                cantidadAcumulada: parseInt(registroEmpresa.cantidadAcumulada),
                fechaUltimoRegistro: registroEmpresa.fechaUltimoRegistro,
                nombreEmpresa: registroEmpresa.nombreEmpresa,
                disabledDate: disableDate
            });
        } else {
            setObjectForm({
                fechaInicio: "",
                fechaFin: "",
                cantidadTotal: 0,
                cantidadAcumulada: 0,
                fechaUltimoRegistro: "",
                nombreEmpresa: "",
                disabledDate: true
            });
        }

    }

    //MÉTODO QUE VALIDA EL CAMPO DE CANTIDAD ACUMULADA DEL FORMULARIO
    const validaCantidaProducida = (rule, value, callback) => {

        if (value > objectForm.cantidadTotal) {
            callback('Excede la cantidad total asignada.')
        }
        else if (value === 0 && objectForm.cantidadAcumulada === 0) {
            callback('Debe registrar una cantidad.')
        }
        else if (value <= objectForm.cantidadAcumulada || (value === 0 )){
            callback('El campo debe ser mayor a la última cantidad acumulada.');
        }
        if(value == objectForm.cantidadTotal){ 
            setDisabledc(false)
        }
        else{
            props.form.setFieldsValue({
                fechaTermino: moment().startOf('day')
            })
            if (value === objectForm.cantidadAcumulada){
                props.form.validateFields(['fechaTermino']);
            }
            if (objectForm.cantidadAcumulada === 0){
                props.form.validateFields(['fechaInicio']);
            }
            setDisabledc(true)
        }
        callback()
    };

    //MÉTODO QUE VALIDA EL CAMPO DE FECHA INICIO DEL FORMULARIO
    const validaFechaInicio = (rule, value, callback, nombre) => {
        //Validacion unicamente para el componente de fechaInicio
        if (moment(value, "DD-MM-YYYY").endOf('day') < moment(objectForm.fechaInicio, "DD-MM-YYYY") 
            && objectForm.cantidadAcumulada === 0 && nombre==='fechaInicio') {
            callback('La fecha no puede ser menor a la fecha de inicio planeada.')
        }
        //Valid que la fecha de inicio no sea mayor a la fecha de captura/termino
        if (moment(props.form.getFieldValue('fechaInicio'), "DD-MM-YYYY").startOf('day') > moment(props.form.getFieldValue('fechaTermino'), "DD-MM-YYYY").startOf('day')){
            //El mensaje es diferente dependiendo si la cantidad producida es igual al total a producir o no
            const mensaje = props.form.getFieldValue('cantidadProducida') >=  objectForm.cantidadTotal
            ? 'La fecha no puede ser mayor a la fecha de término.'
            : 'La fecha no puede ser mayor a la fecha de captura. '
            callback(mensaje)
        }
        callback()
    };
    //MÉTODO QUE VALIDA EL CAMPO DE FECHA FIN DEL FORMULARIO
    const validaFechaFin = (rule, value, callback, nombre) => {
        //Valid que la fecha de inicio no sea mayor a la fecha de captura/termino
        if (moment(props.form.getFieldValue('fechaInicio'), "DD-MM-YYYY").startOf('day') > moment(props.form.getFieldValue('fechaTermino'), "DD-MM-YYYY").startOf('day')
            && nombre==='fechaTermino'){
            callback("La fecha no puede ser menor a la fecha de inicio.")
        }
        if (objectForm.cantidadAcumulada == 0){
            props.form.validateFields(['fechaInicio']);
        }
        callback()
    };


    //MÉTODO QUE GUARDA EL AVANCE EN LA PRODUCCION
    const handleGuardaActa =(e)=> {
        e.preventDefault();
        props.form.validateFields(['empresa', 'fechaInicio', 'cantidadProducida'],(err, values) => {
            if (!err) {
                //Se obtienen los datos directamente desde el form y no desde el parametro values ya que al
                //no validar la fecha fin no nos obtiene ese valor (no se valida la fecha fin ya que casa problemas al guardar)
                const { empresa, fechaInicio, fechaTermino, cantidadProducida } = props.form.getFieldsValue()
                let usuario = jwtDecode(localStorage.getItem('accessToken'));
                let splited = empresa.split("-");

                let data = JSON.stringify({
                    idAprobacion: parseInt(localStorage.getItem('ID_APROBACION_SEG')),
                    idEmpresa: parseInt(splited[1]),
                    idAdjudicacion: parseInt(splited[0]),
                    idArticulo: parseInt(localStorage.getItem("ID_ARTICULO_SEG")),
                    idEstado: parseInt(localStorage.getItem('ID_ESTADO_SELECCIONADO')),
                    idTipoDocumentacion: parseInt(localStorage.getItem('ID_TIPO_DOC_SEG')),
                    fechaInicio: fechaInicio,
                    fechaFin: fechaTermino,
                    cantidadProducida: cantidadProducida,
                    usuario: usuario.sub,

                    anioProceso: localStorage.getItem('ANIO'),
                    idProceso: localStorage.getItem('ID_PROCESO_ELECTORAL'),
                    idDetalleProceso: localStorage.getItem('ID_DETALLE_PROCESO'),
                    tipoProceso: localStorage.getItem('TIPO_PROCESO'),
                })
                setLoading(true)
                saveProduccion(data)
                    .then(resp => {
                        setLoading(false)
                        if (resp.data.entity.code === 200) {
                            message.success("Se guardó correctamente el avance", tiempoMensaje);
                            handleCancel();
                            props.setRefreshTable(true);
                        }
                        else if (resp.data.entity.code == 403) {
                            localStorage.clear();
                            window.location = "/login"
                        } else {
                            setVisibleAlert({
                                visibleAlert: {
                                    activado: true,
                                    tipoMensaje: "error",
                                    mensaje: resp.data.entity.causa
                                }
                            });
                        }
                    }).catch(err => {
                        setLoading(false)
                        if (err.response != null && err.response.status == 403) {
                            localStorage.clear();
                            window.location = "/login"
                            return;
                        }
                        message.error("Ocurrió un error al guardar el avance de producción. Favor de intentar más tarde.", tiempoMensaje);
                    })

            }
        });
    }
        
    return (
        <div>
            <Modal
                visible={props.isVisible}
                footer={[visibleAlert.activado &&
                    (
                        setTimeout(handleCancel(), 80000) //*handleClose={this.handleClose} *
                    )
                ]}
                centered={true}
                closable={false}
            >
                <Form onSubmit={handleGuardaActa} layout="vertical">
                    <Spin spinning={loading} indicator={antIcon} tip="guardando...">
                        <Row>
                            <h2 className="titulo-rosa">{localStorage.getItem("NOMBRE_ARTICULO_SEG")}</h2>
                        </Row>
                        <Row>
                            <Form.Item
                                label={<label className="texto-16-seguimiento">Empresa</label>}
                            >
                                {getFieldDecorator('empresa', {
                                    initialValue: options && options.listaEmpresas.length == 1
                                        ? `${options.listaEmpresas[0].idAdjudicacion}-${options.listaEmpresas[0].idEmpresa}` 
                                        : undefined,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Selecciona una empresa.'
                                        }
                                    ]
                                })(
                                    <Select
                                        //options={options.listaEmpresas}
                                        onChange={onChangeFiltro}
                                        placeholder="Seleccione una opción"
                                        disabled={
                                            (options !== undefined && options !== null
                                                && options.listaEmpresas.length > 0 && options.listaEmpresas.length == 1)
                                            || options === undefined && options === null
                                        }
                                    >   
                                    {options.listaEmpresas.length > 0 &&options.listaEmpresas.map((item) => (
                                        <Option key={`${item.idAdjudicacion}-${item.idEmpresa}`}
                                                value={`${item.idAdjudicacion}-${item.idEmpresa}`}
                                        >
                                            {item.nombreEmpresa}
                                        </Option>
                                    ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <Form.Item
                                    label={<label className="texto-16-seguimiento">Fecha de inicio</label>}
                                >
                                    {getFieldDecorator('fechaInicio', {
                                        initialValue:
                                            (moment(objectForm.fechaUltimoRegistro, "DD-MM-YYYY").endOf('day') < moment(objectForm.fechaInicio, "DD-MM-YYYY").startOf('day') 
                                                ? moment(objectForm.fechaInicio, "DD-MM-YYYY") 
                                                : moment(objectForm.fechaUltimoRegistro, "DD-MM-YYYY").startOf('day') >= moment(objectForm.fechaInicio, "DD-MM-YYYY").startOf('day') 
                                                  && moment(objectForm.fechaUltimoRegistro, "DD-MM-YYYY").endOf('day') <= moment(objectForm.fechaFin, "DD-MM-YYYY").endOf('day') 
                                                    ? moment(objectForm.fechaUltimoRegistro, "DD-MM-YYYY") 
                                                    : moment(objectForm.fechaFin, "DD-MM-YYYY")
                                            ),
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Selecciona una fecha de inicio.'
                                            },
                                            {validator: (rule, value,callback)=>validaFechaInicio(rule, value,callback,'fechaInicio')},
                                        ]
                                    })(
                                        <DatePicker
                                            disabled= {objectForm.cantidadAcumulada > 0 }
                                            format="DD-MM-YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={disabledc 
                                        ? <label className="texto-16-seguimiento">Fecha de captura</label>
                                        : <label className="texto-16-seguimiento">Fecha de término</label>}
                                >
                                    {getFieldDecorator('fechaTermino', {
                                        initialValue:
                                            (moment().endOf('day') < moment(objectForm.fechaInicio, "DD-MM-YYYY").startOf('day') 
                                                ? moment(objectForm.fechaInicio, "DD-MM-YYYY") 
                                                : moment().startOf('day') >= moment(objectForm.fechaInicio, "DD-MM-YYYY").startOf('day') 
                                                  && moment().endOf('day') <= moment(objectForm.fechaFin, "DD-MM-YYYY").endOf('day') 
                                                    ? moment().startOf('day') 
                                                    : moment(objectForm.fechaFin, "DD-MM-YYYY")
                                            ),
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Selecciona la fecha de captura.'
                                            },
                                            {validator: (rule, value,callback)=>validaFechaFin(rule, value,callback,'fechaTermino')},
                                        ]
                                    })(
                                        <DatePicker
                                            disabled={disabledc}
                                            format="DD-MM-YYYY"
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label={<label className="texto-16-seguimiento">Cantidad acumulada</label>}
                                >
                                    {getFieldDecorator('cantidadProducida', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese la cantidad acumulada.'
                                            },
                                            {
                                                pattern: '^[0-9]*$',
                                                message: 'Solo se aceptan números enteros'
                                            },
                                            {
                                                max: 9,
                                                message: 'Tamaño máximo de 9 números.'
                                            },
                                            {validator: validaCantidaProducida},
                                        ]
                                    })(
                                        <Input disabled={objectForm.disabledDate}  />
                                    )
                                    
                                    }
                                </Form.Item>
                            </Col>
                        </Row>
                        {objectForm.nombreEmpresa}
                        {(objectForm.nombreEmpresa==="")
                        ? 
                        <Row >
                            <label className="texto-16-seguimiento"></label> 
                        </Row> 
                        :
                        (objectForm.disabledDate)
                        ? 
                        <Row >
                        <label className="texto-16-bold-seguimiento">
                            {"La fecha actual no se encuentra dentro del rango de fechas asignado. "}
                        </label> 
                        </Row> 
                        :
                        <Row >
                            <label className="texto-16-seguimiento">
                                {"La cantidad acumulada hasta el momento de la empresa "}
                            </label>
                            <label className="texto-16-bold-seguimiento">
                                {objectForm.disabledDate ? "" : objectForm.nombreEmpresa}
                            </label>
                            <label className="texto-16-seguimiento">
                                {" es de "}
                            </label>
                            <label className="texto-16-bold-seguimiento">
                                {objectForm.disabledDate ? "" : objectForm.cantidadAcumulada.toString()}
                            </label>
                            <label className="texto-16-seguimiento">
                                {" piezas "}
                            </label>
                        </Row> 
                        }
                        <br />
                        <br />
                        <Row>
                            <Col span={8} offset={5}>
                                <Form.Item >
                                    <Button 
                                        onClick={handleCancel} 
                                        className="button-cancel"
                                    >
                                        Cancelar
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item >
                                    <Button 
                                        className="button-submit" 
                                        disabled={props.isCau || objectForm.disabledDate} 
                                        type="primary" 
                                        htmlType="submit"
                                    >
                                        Guardar
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Spin>
                </Form>
            </Modal>
        </div>
    );

    //}

}

const FormActaSeguimientoModal = Form.create()(FormActaSeguimiento);
export default withRouter(FormActaSeguimientoModal);
